import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';

/**
 * The SisterPlayer generates an iframe with the src pointing to the sister asset.
 * It leverages the ref attribute to attach a load event for the onPlayerReady and onPlay prop callbacks.
 */
class SisterPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.iframeRef = null;
    this.state = {
      src: props.src,
      isVideoReady: false
    };
    this.loadPlayer = this.loadPlayer.bind(this);
    this.handleIframeLoad = this.handleIframeLoad.bind(this);
  }
  componentDidMount() {
    this.iframeRef?.addEventListener('load', this.handleIframeLoad);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.active) {
      this.setState({
        src: this.props.src
      });
    } else {
      this.setState({
        src: ''
      });
    }
  }
  componentWillUnmount() {
    this.setState({
      src: ''
    });
    this.iframeRef?.removeEventListener('load', this.handleIframeLoad);
  }
  handleIframeLoad() {
    this.setState({
      isVideoReady: true
    });
    this.props.onPlayerReady();
    this.props.onPlay();
  }
  loadPlayer() {
    const {
      placeholder
    } = this.props;
    const {
      isVideoReady
    } = this.state;
    const frameProps = {
      id: this.props.videoId,
      width: this.props.width,
      height: this.props.height,
      frameBorder: 0,
      scrolling: 'no',
      src: this.state.src
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isVideoReady && placeholder, /*#__PURE__*/React.createElement("iframe", Object.assign({
      title: "sister video",
      ref: ref => {
        this.iframeRef = ref;
      }
    }, frameProps)));
  }

  /**
  * Play video
  */
  play() {
    this.setState({
      src: this.props.src
    });
  }

  /**
  * Pause video
  */
  pause() {}

  /**
  * Mute video
  */
  mute() {}

  /**
  * Stop video
  */
  stop() {}
  render() {
    return /*#__PURE__*/_jsx("div", {
      "data-cmp": "sisterPlayer",
      className: `${this.props.className || ''} video-player sister-video`
    }, void 0, /*#__PURE__*/React.createElement("div", {
      id: `v${this.props.videoId}`,
      ref: ref => {
        this.refId = ref;
      }
    }, this.loadPlayer()));
  }
}
SisterPlayer.defaultProps = {
  active: true
};
export default SisterPlayer;